import {
  EvaluateInvestmentProfileInterface,
  EvaluateInvestorProfileInterface,
  EvaluateResultInterface,
} from '../interfaces/evaluate-result.interface';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('EvaluateInvestorProfileModel')
export class EvaluateInvestorProfileModel
  implements EvaluateInvestorProfileInterface
{
  @JsonProperty('AllowReprofile', Boolean, true)
  allowReprofile: boolean = undefined;

  @JsonProperty('MifidCompetenceId', Number, true)
  mifidCompetenceId: number = undefined;

  @JsonProperty('MifidCompetenceName', String, true)
  mifidCompetenceName: string = undefined;

  @JsonProperty('MifidCompetenceScore', Number, true)
  mifidCompetenceScore: number = undefined;

  @JsonProperty('ProfileId', String, true)
  profileId: string = undefined;

  @JsonProperty('ProfileName', String, true)
  profileName: string = undefined;

  @JsonProperty('ProfileScore', Number, true)
  profileScore: number = undefined;

  @JsonProperty('ProfileTestSignatureStatus', String, true)
  profileTestSignatureStatus: string = undefined;

  @JsonProperty('ProfileTestSignatureType', String, true)
  profileTestSignatureType: string = undefined;

  @JsonProperty('ProfileTimeHorizon', String, true)
  profileTimeHorizon: string = undefined;

  @JsonProperty('TestDate', String, true)
  testDate: string = undefined;

  @JsonProperty('TestExpirationDate', String, true)
  testExpirationDate: string = undefined;

  @JsonProperty('TestExpired', Boolean, true)
  testExpired: boolean = undefined;

  @JsonProperty('TestId', String, true)
  testId: string = undefined;

  @JsonProperty('TestIdView', String, true)
  testIdView: string = undefined;
}

@JsonObject('EvaluateInvestmentProfileModel')
export class EvaluateInvestmentProfileModel {
  @JsonProperty('ProfileId', String, true)
  profileId: string = undefined;

  @JsonProperty('ProfileName', String, true)
  profileName: string = undefined;

  @JsonProperty('ProfileScore', Number, true)
  profileScore: number = undefined;

  @JsonProperty('ProfileTestId', String, true)
  profileTestId: string;

  @JsonProperty('ProfileTestSignatureStatus', String, true)
  profileTestSignatureStatus: string = undefined;

  @JsonProperty('ProfileTestSignatureType', String, true)
  profileTestSignatureType: string = undefined;

  @JsonProperty('TestDate', String, true)
  testDate: string = undefined;
}

@JsonObject('EvaluateResultModel')
export class EvaluateResultModel implements EvaluateResultInterface {
  @JsonProperty('Incoherences', [String], true)
  incoherences: string[] = undefined;

  @JsonProperty('InvestmentProfile', EvaluateInvestorProfileModel, true)
  investmentProfileData: EvaluateInvestmentProfileInterface = undefined;

  @JsonProperty('InvestorProfile', EvaluateInvestorProfileModel, true)
  investorProfileData: EvaluateInvestorProfileInterface = undefined;

  @JsonProperty('IsValid', Boolean, true)
  isValid: boolean = undefined;
}
